<template>
  <div class="ksm-flex-1 ksm-flex-column">
    <div class="ksm-flex-1 ksm-flex">
      <div class="ksm-flex-00auto">
        <div class="ksm-medien__icon" v-html="$_getSvg('film-neu.svg')"></div>
      </div>
      <div class="ksm-flex-1 ksm-flex">
        <div class="ksm-flex-1" style="position:relative">
          <div class="ksm-media-wrapper">
            <video class="ksm-media">
              <source src="./static/multimedia/film.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
    <div class="ksm-flex-00auto ksm-flex">
      <div>
        <div class="ksm-medien__audio-select">Stummfilm (1929)</div>
      </div>
      <div class="ksm-flex-1">
        <PlayerControls
          v-if="media"
          :media="media"
          mediaType="video"
          :mediaName="'Film'"
          :playBtnDisable="isConnect2"
          @videoPlaying="videoPlaying"
          @playPause="playPause"
        ></PlayerControls>
      </div>
    </div>
  </div>
</template>

<script>
import PlayerControls from "./PlayerControls";

export default {
  components: { PlayerControls },
  props: ["isConnect2"],
  data() {
    return {
      duration: 0,
      media: null,
      isPause: true
    };
  },
  mounted: function() {
    const vue = this;
    const media = this.$el.querySelector(".ksm-media");
    this.media = media;
    media.addEventListener("play", function() {
      // console.log("film play");
      if (vue.isConnect2) {
        // vue.$store.state.eventBus.$emit("audio-play", vue.media.currentTime);
      }
    });

    media.addEventListener("pause", function() {
      // console.log("film pause");
      if (vue.isConnect2) {
        // vue.$store.state.eventBus.$emit("audio-pause");
      }
    });
  },
  methods: {
    videoPlaying() {
      this.$emit("videoPlaying");
    },
    playPause(d) {
      this.isPause = d;
    }
  }
};
</script>

<style lang="scss" >
</style>


// WEBPACK FOOTER //
// FilmView.vue?4b5e51fd